import { Injectable } from '@angular/core';
var ColumnBaseService = /** @class */ (function () {
    function ColumnBaseService() {
    }
    ColumnBaseService.prototype.getColKey = function (compName, key, index) {
        var comp = compName ? compName + '.' : '';
        var idx = (typeof index !== 'undefined' && index !== null) ? '-' + index : '';
        if (typeof key !== 'undefined') {
            return comp + key + idx;
        }
        else {
            return '';
        }
    };
    ColumnBaseService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ColumnBaseService.ctorParameters = function () { return []; };
    return ColumnBaseService;
}());
export { ColumnBaseService };
//# sourceMappingURL=columnbase.service.js.map